import React, { FC, ReactElement, ReactNode } from 'react';

import css from './style.module.scss';

interface IProps {
  children: ReactElement | ReactElement[] | ReactNode;
}

const ArticleBlockMain: FC<IProps> = ({ children }) => {
  return <main className={css.articleBlock__main}>{children}</main>;
};

export default ArticleBlockMain;
